<template>
    <div class="smr-toggle ui-center-vertically chips-bold">
        <div class="smr-toggle__item ui-center-content" :class="{ 'is-active' : this.data }" @click="clickHandler(true)">
            Ein
        </div>
        <div class="smr-toggle__item ui-center-content" :class="{ 'is-active' : !this.data }" @click="clickHandler(false)">
            Aus
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: false
        }
    },
    watch: {
        value(val) {
            if(val !== this.data) {
                this.data = val
            }
        }
    },
    mounted() {
        this.setInitialValue()
    },
    methods: {
        clickHandler(e) {
            this.data = e
            this.emitChange()
        },
        setInitialValue() {
            if(this.value) {
                this.data = this.value
            }
        },
        emitChange() {
            this.$emit('change', this.data);
        },
    }
}
</script>

<style lang="scss">
.smr-toggle {
    background: $color-black-005;
    border-radius: 6px;

    &__item {
        cursor: pointer;
        height: 34px;
        border-radius: 6px;
        padding: 0 13px;

        .no-touch &:hover {
                background-color: $color-black-003;
            }

        &.is-active {
            background: $color-yellow;
            pointer-events: none;
            .no-touch &:hover {
                background: $color-yellow;
            }
        }
    }
}
</style>